import React from "react";
import dayjs from "dayjs";

// Native <input type="date"> replacement for the former MUI x-date-pickers
// DatePicker. Keeps the same prop contract so existing consumers work
// unchanged: onChange(name, date) where `date` is a dayjs object (or null).
const toInputValue = (v) => {
  if (!v) return "";
  const d = dayjs.isDayjs(v) ? v : dayjs(v);
  return d.isValid() ? d.format("YYYY-MM-DD") : "";
};

const CustomDatePicker = ({
  name,
  value,
  onChange,
  disabled,
  minDate,
  maxDate,
}) => {
  const handleChange = (e) => {
    const val = e.target.value; // "YYYY-MM-DD" or ""
    // Preserve the previous contract: hand the parent a dayjs object (or null).
    onChange(name, val ? dayjs(val) : null);
  };

  return (
    <input
      type="date"
      name={name}
      defaultValue={toInputValue(value)}
      onChange={handleChange}
      disabled={disabled}
      min={minDate ? toInputValue(minDate) : undefined}
      max={maxDate ? toInputValue(maxDate) : undefined}
      className="input-border-none focus:outline-none focus:shadow-outline w-full"
    />
  );
};

export default CustomDatePicker;
